import styled from 'styled-components'

export default styled.div`
  margin: 0;
  position: absolute;
  width: auto;
  height: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, calc(-50% - 25px));
  > div {
    transform: translateX(5px);
  }
`



// WEBPACK FOOTER //
// ./src/styles/PageMiddleSpinner.js